import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { EsitoSpedizioneDiffida } from '../../../models/esito-spedizione-diffida';
import { LettereDiffidaEsitoSpedizioneUpdate } from './lettere-diffida-esito-spedizione-update';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [lettere-diffida-esito-spedizione-update-mod]',
  templateUrl: 'lettere-diffida-esito-spedizione-update-mod.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class LettereDiffidaEsitoSpedizioneUpdateMod {
  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('formEsitoSpedizione') formEsitoSpedizione: LettereDiffidaEsitoSpedizioneUpdate;

  inizializza(urlAddEsitoSpedizione: string, idLetteraDiffida: string, idSezione: string, esitoSpedizione: EsitoSpedizioneDiffida) {
    this.formEsitoSpedizione.inizializza(urlAddEsitoSpedizione, idLetteraDiffida, idSezione, esitoSpedizione);
    openModal('modalmodesitispedizioneupdate');
  }

  createForm() {
    this.formEsitoSpedizione.createForm();
  }

  manageModal() {
      closeModal('modalmodesitispedizioneupdate');
      this.onReturn.emit();
  }
}
